import React, { useEffect, useState } from 'react'
import Header from '../../../components/header/Header'
import ExperienceFilterContainer from '../container/experience.filter.container/ExperienceFilterContainer'
import ExperienceActionContainer from '../container/experience.action.container/ExperienceActionContainer'
import { useAppSelector } from '../../../app/hooks'
import { type Category } from '../../category/types/types'
import { selectedProject } from '../../home/appSlice/appslice'
import { type SubCategory } from '../../subcategory/types/types'
import { type EntityId, type EntityState } from '@reduxjs/toolkit'
import { type ExperienceCard } from '../types/types'
import { useDeleteExprienceMutation, useLazyGetAllExperiencesQuery } from '../api/experienceCardApiSlice'
import ExperiecneListContainer from '../container/expereinceListContainer/ExperiecneListContainer'
import { useNavigate } from 'react-router-dom'
import Loading from '../../../components/Loading/Loading'
import { selectAdmin } from '../../auth/authSlice/authSlice'

const ExperienceMainPage = () => {
  const project = useAppSelector(selectedProject)
  const projectApp = useAppSelector(selectedProject)
  const admin = useAppSelector(selectAdmin)
  const navigate = useNavigate()
  const [ deleteExperPreReq,{isLoading:expLoading} ] = useDeleteExprienceMutation()
  const [category, setCategory] = useState<Partial<Category> | null>(null)
  const [subCategory, setSubCategory] = useState<Partial<SubCategory> | null>(
    null
  )
  const [page, setPage] = useState<number>(1)
  const [limit, setLimit] = useState<number>(25)
  const [sort, setSort] = useState<string>('position')
  const [term, setTerm] = useState<string>('null')
  const [listStatus, setListStatus] = useState<'publish' | 'save'>('publish')
  const [loading, setLoading] = useState<boolean>(false)
  const [experienceCards, setExperienceCards] =
    useState<EntityState<ExperienceCard> | null>(null)
    const [reload,setReload] = useState<boolean>(false);

  const [getAllExperiences, { isSuccess }] =
    useLazyGetAllExperiencesQuery();
  useEffect(() => {
    if (!projectApp) {
      navigate('/')
    }
  }, [projectApp])

  useEffect(() => {
    (async () => {
      try {
        setLoading(true)
        const expList = await getAllExperiences({
          project: project!._id!,
          category: category?._id,
          subCategory: subCategory?._id,
          expPublish: listStatus === 'publish',
          expSave: listStatus === 'save',
          page,
          limit,
          sort,
          term,
        }).unwrap();
        setExperienceCards(expList);
        setLoading(false);
      } catch (error) {
        console.error(error)
      }
    })();
  }, [category, subCategory, page, limit, sort, term, listStatus,expLoading,experienceCards,reload,deleteExperPreReq]);

  useEffect(() => {
    if (admin) {
      const projectPermession = admin.projectAccess?.find(
        (item) => String(item.project) === String(projectApp?._id)
      )

      if (projectPermession) {
        if (projectPermession?.accessType === 'Full') {
          // setShowAddStudentButton(projectPermession.users!);
        }
      }

      if (admin.categoryAccess?.length === 1) {
        if (admin.categoryAccess[0].accessType === 'Full') {
          setCategory({ _id: admin.categoryAccess[0].category as EntityId })
        } else {
          setCategory({ _id: admin.categoryAccess[0].category as EntityId })
          setSubCategory({
            _id: admin.subCategoryAccess![0].subcategory as EntityId
          })
        }
      }
    }
  }, [admin])

  useEffect(() => {
    // se(studentList!);
    if (term !== 'null' && page > 1) {
      setPage(1)
    } else {
      setPage(page)
    }
  }, [term])

  const onCatgoryHandler = (category: Partial<Category> | null) => {
    setCategory(category)
  }

  const onSubCategoryHandler = (subCategory: Partial<SubCategory> | null) => {
    setSubCategory(subCategory)
  }
  const onTrem = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value !== '') {
      setTerm(e.target.value)
    } else {
      setTerm('null')
    }
  }

  const onSort = (fieldName: string) => {
    if (sort === 'null') {
      setSort(`-${fieldName}`)
    }
    if (sort.startsWith('-')) {
      setSort(fieldName)
    }
    if (!sort.startsWith('-')) {
      setSort(`-${fieldName}`)
    }
  }

  const onPublish = () => {
    setListStatus('publish')
  }
  const onSave = () => {
    setListStatus('save')
  }

  const onPage = (pageNumber: number) => {
    setPage(pageNumber)
  }

  const onLimit = (limitNumber: number) => {
    setLimit(limitNumber)
  }

    const onDelete = async  ( id: EntityId) => {
     if (confirm('Are you sure to remove this Experience?')) {
     
        try {
         await deleteExperPreReq(id).unwrap();
         setReload(!reload);
        } catch (error) {
          setReload(!reload);
          console.error(error)
        }
    }

      
    }

  let content
  if (loading) {
    content = (
      <>
        <Header title="Experience" />
        <ExperienceFilterContainer
          project={project!}
          category={category}
          subCategory={subCategory}
          onCategoryHandler={onCatgoryHandler}
          onSubCategoryHandler={onSubCategoryHandler}
        />
        <ExperienceActionContainer
          onTerm={onTrem}
          listStatus={listStatus}
          onPublish={onPublish}
          onSave={onSave}
          term={term}
          lastPosition={0}
        />
        <Loading />;
      </>
    )
  } else if (isSuccess) {
    content = (
      <>
        {projectApp && (
          <>
            <Header title="Experience" />
            <ExperienceFilterContainer
              project={project!}
              category={category}
              subCategory={subCategory}
              onCategoryHandler={onCatgoryHandler}
              onSubCategoryHandler={onSubCategoryHandler}
            />
            <ExperienceActionContainer
              onTerm={onTrem}
              listStatus={listStatus}
              onPublish={onPublish}
              onSave={onSave}
              term={term}
              lastPosition={experienceCards && Array.isArray(experienceCards.entities) ? experienceCards.entities.filter((item: any) => item?.timingType === 'Delayed').length : 0}
            />
            {isSuccess && experienceCards && (
              <ExperiecneListContainer
                list={experienceCards}
                onSort={onSort}
                sort={sort}
                page={page}
                limit={limit}
                onPage={onPage}
                onLimit={onLimit}
                onDelete={onDelete}
              />
            )}{' '}
          </>
        )}
      </>
    )
  }

  return <>{content}</>
}

export default ExperienceMainPage
